import { Action } from '@ngrx/store';
import { type } from '../util';
import { TechnicalError } from '../../models/errors.model';

export const ActionTypes = {
  CHANGE_PASSWORD: type('[ChangePassword] Change Password'),
  SUCCESS: type('[ChangePassword] Success'),
  ERROR: type('[ChangePassword] Error'),
  RESET_SUCCESS: type('[ChangePassword] Reset Success'),
  RESET_ERROR: type('[ChangePassword] Reset Error'),
};

/**
 * Action implementations
 */
export class ChangePasswordAction implements Action {
  type = ActionTypes.CHANGE_PASSWORD;

  constructor(public payload: string) {}
}

export class ChangePasswordSuccessAction implements Action {
  type = ActionTypes.SUCCESS;
  payload = null;
}

export class ChangePasswordErrorAction implements Action {
  type = ActionTypes.ERROR;

  constructor(public payload: TechnicalError) {}
}

export class ResetSuccess implements Action {
  type = ActionTypes.RESET_SUCCESS;
  payload = null;
}

export class ResetError implements Action {
  type = ActionTypes.RESET_ERROR;
  payload = null;
}

/**
 * Export of all type alias actions
 */
export type Actions =
  | ChangePasswordErrorAction
  | ChangePasswordAction
  | ChangePasswordSuccessAction
  | ResetSuccess
  | ResetError;
